import React from 'react';

import { useRedirectToAccountIfUser } from 'Utilities/hooks';

import { ComponentsWrapper } from 'Layout';

import { useAuthUI } from '../experiments/useAuthUI/useAuthUI';
import { Authorize } from '../fastlane/authorize/Authorize';
import { SignIn } from '../fastlane/signIn/SignIn';

const SignInContainer = () => {
  const { isAuthUIJourney } = useAuthUI();
  useRedirectToAccountIfUser();

  if (isAuthUIJourney) {
    return (<Authorize />);
  }

  return (
    <ComponentsWrapper>
      <SignIn />
    </ComponentsWrapper>
  );
};

export default SignInContainer;
